import { Component } from "@angular/core";
import { ModalInjectComponentComponent } from "../modal-inject-component/modal-inject-component.component";

@Component({
    selector: "app-modal-bet-slip",
    templateUrl: "./modal-bet-slip.component.html",
    styleUrls: ["./modal-bet-slip.component.scss"],
})
export class ModalBetSlipComponent extends ModalInjectComponentComponent {}
